module.exports = __webpack_public_path__ + "static/img/image-selling-cars-process_light.b2eeee3f.png";